import _objectSpread from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// these cannot be dynamically imported
import { TypedDataUtils } from '@metamask/eth-sig-util';
var LEDGER_LIVE_PATH = "m/44'/60'";
var LEDGER_DEFAULT_PATH = "m/44'/60'/0'";
var DEFAULT_BASE_PATHS = [{
  label: 'Ledger Live',
  value: LEDGER_LIVE_PATH
}, {
  label: 'Ledger Legacy',
  value: LEDGER_DEFAULT_PATH
}];
var assets = [{
  label: 'ETH'
}];

var supportsWebUSB = function supportsWebUSB() {
  return Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices === 'function');
};
/**
 * Returns the correct ledger transport based on browser compatibility for webUSB.
 * @returns
 */


var getTransport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return supportsWebUSB();

          case 2:
            if (!_context.sent) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return import('@ledgerhq/hw-transport-webusb');

          case 5:
            _context.t0 = _context.sent.default;
            _context.next = 11;
            break;

          case 8:
            _context.next = 10;
            return import('@ledgerhq/hw-transport-u2f');

          case 10:
            _context.t0 = _context.sent.default;

          case 11:
            return _context.abrupt("return", _context.t0.create());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTransport() {
    return _ref.apply(this, arguments);
  };
}();

var getAccount = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(derivationPath, asset, index, provider, eth) {
    var dPath, _yield$eth$getAddress, address;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dPath = derivationPath === LEDGER_LIVE_PATH ? "".concat(derivationPath, "/").concat(index, "'/0/0") : "".concat(derivationPath, "/").concat(index);
            _context2.next = 3;
            return eth.getAddress(dPath);

          case 3:
            _yield$eth$getAddress = _context2.sent;
            address = _yield$eth$getAddress.address;
            _context2.t0 = dPath;
            _context2.t1 = address;
            _context2.t2 = asset.label;
            _context2.next = 10;
            return provider.getBalance(address);

          case 10:
            _context2.t3 = _context2.sent;
            _context2.t4 = {
              asset: _context2.t2,
              value: _context2.t3
            };
            return _context2.abrupt("return", {
              derivationPath: _context2.t0,
              address: _context2.t1,
              balance: _context2.t4
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAccount(_x, _x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getAddresses = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(derivationPath, asset, provider, eth) {
    var accounts, index, zeroBalanceAccounts, acc;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            accounts = [];
            index = 0;
            zeroBalanceAccounts = 0; // Iterates until a 0 balance account is found
            // Then adds 4 more 0 balance accounts to the array

          case 3:
            if (!(zeroBalanceAccounts < 5)) {
              _context3.next = 11;
              break;
            }

            _context3.next = 6;
            return getAccount(derivationPath, asset, index, provider, eth);

          case 6:
            acc = _context3.sent;

            if (acc.balance.value.isZero()) {
              zeroBalanceAccounts++;
              accounts.push(acc);
            } else {
              accounts.push(acc); // Reset the number of 0 balance accounts

              zeroBalanceAccounts = 0;
            }

            index++;
            _context3.next = 3;
            break;

          case 11:
            return _context3.abrupt("return", accounts);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getAddresses(_x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

function ledger() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      customNetwork = _ref4.customNetwork;

  var getIcon = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return import('./icon.js');

            case 2:
              return _context4.abrupt("return", _context4.sent.default);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getIcon() {
      return _ref5.apply(this, arguments);
    };
  }();

  return function () {
    var accounts;
    return {
      label: 'Ledger',
      getIcon: getIcon,
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(_ref6) {
          var EventEmitter, chains, Eth, ethUtil, _yield$import, SignTypedDataVersion, _yield$import2, StaticJsonRpcProvider, _yield$import3, accountSelect, createEIP1193Provider, ProviderRpcError, getCommon, bigNumberFieldsToStrings, getHardwareWalletProvider, _yield$import4, Transaction, Capability, transport, eth, eventEmitter, ethersProvider, currentChain, scanAccounts, getAccounts, signMessage, ledgerProvider, provider;

          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  EventEmitter = _ref6.EventEmitter, chains = _ref6.chains;
                  _context18.next = 3;
                  return import('@ledgerhq/hw-app-eth');

                case 3:
                  Eth = _context18.sent.default;
                  _context18.next = 6;
                  return import('ethereumjs-util');

                case 6:
                  ethUtil = _context18.sent;
                  _context18.next = 9;
                  return import('@metamask/eth-sig-util');

                case 9:
                  _yield$import = _context18.sent;
                  SignTypedDataVersion = _yield$import.SignTypedDataVersion;
                  _context18.next = 13;
                  return import('@ethersproject/providers');

                case 13:
                  _yield$import2 = _context18.sent;
                  StaticJsonRpcProvider = _yield$import2.StaticJsonRpcProvider;
                  _context18.next = 17;
                  return import('@web3-onboard/common');

                case 17:
                  _yield$import3 = _context18.sent;
                  accountSelect = _yield$import3.accountSelect;
                  createEIP1193Provider = _yield$import3.createEIP1193Provider;
                  ProviderRpcError = _yield$import3.ProviderRpcError;
                  getCommon = _yield$import3.getCommon;
                  bigNumberFieldsToStrings = _yield$import3.bigNumberFieldsToStrings;
                  getHardwareWalletProvider = _yield$import3.getHardwareWalletProvider;
                  _context18.next = 26;
                  return import('@ethereumjs/tx');

                case 26:
                  _yield$import4 = _context18.sent;
                  Transaction = _yield$import4.TransactionFactory;
                  Capability = _yield$import4.Capability;
                  _context18.next = 31;
                  return getTransport();

                case 31:
                  transport = _context18.sent;
                  eth = new Eth(transport);
                  eventEmitter = new EventEmitter();
                  currentChain = chains[0];

                  scanAccounts = /*#__PURE__*/function () {
                    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref7) {
                      var derivationPath, chainId, asset, _yield$eth$getAddress2, address, statusText;

                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              derivationPath = _ref7.derivationPath, chainId = _ref7.chainId, asset = _ref7.asset;
                              _context5.prev = 1;
                              currentChain = chains.find(function (_ref9) {
                                var id = _ref9.id;
                                return id === chainId;
                              }) || currentChain;
                              ethersProvider = new StaticJsonRpcProvider(currentChain.rpcUrl); // Checks to see if this is a custom derivation path
                              // If it is then just return the single account

                              if (!(derivationPath !== LEDGER_LIVE_PATH && derivationPath !== LEDGER_DEFAULT_PATH)) {
                                _context5.next = 18;
                                break;
                              }

                              _context5.next = 7;
                              return eth.getAddress(derivationPath);

                            case 7:
                              _yield$eth$getAddress2 = _context5.sent;
                              address = _yield$eth$getAddress2.address;
                              _context5.t0 = derivationPath;
                              _context5.t1 = address;
                              _context5.t2 = asset.label;
                              _context5.next = 14;
                              return ethersProvider.getBalance(address);

                            case 14:
                              _context5.t3 = _context5.sent;
                              _context5.t4 = {
                                asset: _context5.t2,
                                value: _context5.t3
                              };
                              _context5.t5 = {
                                derivationPath: _context5.t0,
                                address: _context5.t1,
                                balance: _context5.t4
                              };
                              return _context5.abrupt("return", [_context5.t5]);

                            case 18:
                              return _context5.abrupt("return", getAddresses(derivationPath, asset, ethersProvider, eth));

                            case 21:
                              _context5.prev = 21;
                              _context5.t6 = _context5["catch"](1);
                              statusText = _context5.t6.statusText;
                              throw new Error(statusText === 'UNKNOWN_ERROR' ? 'Ledger device is locked, please unlock to continue' : statusText);

                            case 25:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, null, [[1, 21]]);
                    }));

                    return function scanAccounts(_x11) {
                      return _ref8.apply(this, arguments);
                    };
                  }();

                  getAccounts = /*#__PURE__*/function () {
                    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return accountSelect({
                                basePaths: DEFAULT_BASE_PATHS,
                                assets: assets,
                                chains: chains,
                                scanAccounts: scanAccounts
                              });

                            case 2:
                              accounts = _context6.sent;

                              if (accounts && accounts.length) {
                                eventEmitter.emit('accountsChanged', [accounts[0].address]);
                              }

                              return _context6.abrupt("return", accounts);

                            case 5:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function getAccounts() {
                      return _ref10.apply(this, arguments);
                    };
                  }();

                  signMessage = /*#__PURE__*/function () {
                    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(address, message) {
                      var account;
                      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              if (accounts && accounts.length && accounts.length > 0) {
                                _context7.next = 2;
                                break;
                              }

                              throw new Error('No account selected. Must call eth_requestAccounts first.');

                            case 2:
                              account = accounts.find(function (account) {
                                return account.address === address;
                              }) || accounts[0];
                              return _context7.abrupt("return", eth.signPersonalMessage(account.derivationPath, ethUtil.stripHexPrefix(message)).then(function (result) {
                                var v = (result['v'] - 27).toString(16);

                                if (v.length < 2) {
                                  v = '0' + v;
                                }

                                return "0x".concat(result['r']).concat(result['s']).concat(v);
                              }));

                            case 4:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));

                    return function signMessage(_x12, _x13) {
                      return _ref11.apply(this, arguments);
                    };
                  }();

                  ledgerProvider = getHardwareWalletProvider(function () {
                    return currentChain === null || currentChain === void 0 ? void 0 : currentChain.rpcUrl;
                  });
                  provider = createEIP1193Provider(ledgerProvider, {
                    eth_requestAccounts: function () {
                      var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                        var accounts;
                        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                          while (1) {
                            switch (_context8.prev = _context8.next) {
                              case 0:
                                _context8.next = 2;
                                return getAccounts();

                              case 2:
                                accounts = _context8.sent;

                                if (Array.isArray(accounts)) {
                                  _context8.next = 5;
                                  break;
                                }

                                throw new Error('No account selected. Must call eth_requestAccounts first.');

                              case 5:
                                if (!(accounts.length === 0)) {
                                  _context8.next = 7;
                                  break;
                                }

                                throw new ProviderRpcError({
                                  code: 4001,
                                  message: 'User rejected the request.'
                                });

                              case 7:
                                if (accounts[0].hasOwnProperty('address')) {
                                  _context8.next = 9;
                                  break;
                                }

                                throw new Error('No address property associated with the selected account');

                              case 9:
                                return _context8.abrupt("return", [accounts[0].address]);

                              case 10:
                              case "end":
                                return _context8.stop();
                            }
                          }
                        }, _callee8);
                      }));

                      function eth_requestAccounts() {
                        return _eth_requestAccounts.apply(this, arguments);
                      }

                      return eth_requestAccounts;
                    }(),
                    eth_selectAccounts: function () {
                      var _eth_selectAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                        var accounts;
                        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                          while (1) {
                            switch (_context9.prev = _context9.next) {
                              case 0:
                                _context9.next = 2;
                                return getAccounts();

                              case 2:
                                accounts = _context9.sent;
                                return _context9.abrupt("return", accounts.map(function (_ref12) {
                                  var address = _ref12.address;
                                  return address;
                                }));

                              case 4:
                              case "end":
                                return _context9.stop();
                            }
                          }
                        }, _callee9);
                      }));

                      function eth_selectAccounts() {
                        return _eth_selectAccounts.apply(this, arguments);
                      }

                      return eth_selectAccounts;
                    }(),
                    eth_accounts: function () {
                      var _eth_accounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
                        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                          while (1) {
                            switch (_context10.prev = _context10.next) {
                              case 0:
                                return _context10.abrupt("return", Array.isArray(accounts) && accounts.length && accounts[0].hasOwnProperty('address') ? [accounts[0].address] : []);

                              case 1:
                              case "end":
                                return _context10.stop();
                            }
                          }
                        }, _callee10);
                      }));

                      function eth_accounts() {
                        return _eth_accounts.apply(this, arguments);
                      }

                      return eth_accounts;
                    }(),
                    eth_chainId: function () {
                      var _eth_chainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                          while (1) {
                            switch (_context11.prev = _context11.next) {
                              case 0:
                                return _context11.abrupt("return", currentChain && currentChain.id || '');

                              case 1:
                              case "end":
                                return _context11.stop();
                            }
                          }
                        }, _callee11);
                      }));

                      function eth_chainId() {
                        return _eth_chainId.apply(this, arguments);
                      }

                      return eth_chainId;
                    }(),
                    eth_signTransaction: function () {
                      var _eth_signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref13) {
                        var _ref13$params, transactionObject, account, _account, from, derivationPath, chainId, common, signer, populatedTransaction, transaction, unsignedTx, _yield$eth$signTransa, v, r, s, signedTx;

                        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                          while (1) {
                            switch (_context12.prev = _context12.next) {
                              case 0:
                                _ref13$params = _slicedToArray(_ref13.params, 1), transactionObject = _ref13$params[0];

                                if (!(!accounts || !Array.isArray(accounts) || !accounts.length)) {
                                  _context12.next = 3;
                                  break;
                                }

                                throw new Error('No account selected. Must call eth_requestAccounts first.');

                              case 3:
                                if (transactionObject.hasOwnProperty('from')) {
                                  account = accounts.find(function (account) {
                                    return account.address === transactionObject.from;
                                  });
                                }

                                account = account ? account : accounts[0];
                                _account = account, from = _account.address, derivationPath = _account.derivationPath; // Set the `from` field to the currently selected account

                                transactionObject = _objectSpread(_objectSpread({}, transactionObject), {}, {
                                  from: from
                                });
                                chainId = currentChain.hasOwnProperty('id') ? Number.parseInt(currentChain.id) : 1;
                                _context12.next = 10;
                                return getCommon({
                                  customNetwork: customNetwork,
                                  chainId: chainId
                                });

                              case 10:
                                common = _context12.sent;
                                transactionObject.gasLimit = transactionObject.gas || transactionObject.gasLimit; // 'gas' is an invalid property for the TransactionRequest type

                                delete transactionObject.gas;
                                signer = ethersProvider.getSigner(from);
                                _context12.next = 16;
                                return signer.populateTransaction(transactionObject);

                              case 16:
                                populatedTransaction = _context12.sent;
                                populatedTransaction = bigNumberFieldsToStrings(populatedTransaction);
                                transaction = Transaction.fromTxData(populatedTransaction, {
                                  common: common
                                });
                                unsignedTx = transaction.getMessageToSign(false); // If this is not an EIP1559 transaction then it is legacy and it needs to be
                                // rlp encoded before being passed to ledger

                                if (!transaction.supports(Capability.EIP1559FeeMarket)) {
                                  unsignedTx = ethUtil.rlp.encode(unsignedTx);
                                }

                                _context12.next = 23;
                                return eth.signTransaction(derivationPath, unsignedTx.toString('hex'));

                              case 23:
                                _yield$eth$signTransa = _context12.sent;
                                v = _yield$eth$signTransa.v;
                                r = _yield$eth$signTransa.r;
                                s = _yield$eth$signTransa.s;
                                // Reconstruct the signed transaction
                                signedTx = Transaction.fromTxData(_objectSpread(_objectSpread({}, populatedTransaction), {}, {
                                  v: "0x".concat(v),
                                  r: "0x".concat(r),
                                  s: "0x".concat(s)
                                }), {
                                  common: common
                                });
                                return _context12.abrupt("return", signedTx ? "0x".concat(signedTx.serialize().toString('hex')) : '');

                              case 29:
                              case "end":
                                return _context12.stop();
                            }
                          }
                        }, _callee12);
                      }));

                      function eth_signTransaction(_x14) {
                        return _eth_signTransaction.apply(this, arguments);
                      }

                      return eth_signTransaction;
                    }(),
                    eth_sendTransaction: function () {
                      var _eth_sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref14) {
                        var baseRequest, params, signedTx, transactionHash;
                        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                          while (1) {
                            switch (_context13.prev = _context13.next) {
                              case 0:
                                baseRequest = _ref14.baseRequest, params = _ref14.params;
                                _context13.next = 3;
                                return provider.request({
                                  method: 'eth_signTransaction',
                                  params: params
                                });

                              case 3:
                                signedTx = _context13.sent;
                                _context13.next = 6;
                                return baseRequest({
                                  method: 'eth_sendRawTransaction',
                                  params: [signedTx]
                                });

                              case 6:
                                transactionHash = _context13.sent;
                                return _context13.abrupt("return", transactionHash);

                              case 8:
                              case "end":
                                return _context13.stop();
                            }
                          }
                        }, _callee13);
                      }));

                      function eth_sendTransaction(_x15) {
                        return _eth_sendTransaction.apply(this, arguments);
                      }

                      return eth_sendTransaction;
                    }(),
                    eth_sign: function () {
                      var _eth_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref15) {
                        var _ref15$params, address, message;

                        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                          while (1) {
                            switch (_context14.prev = _context14.next) {
                              case 0:
                                _ref15$params = _slicedToArray(_ref15.params, 2), address = _ref15$params[0], message = _ref15$params[1];
                                return _context14.abrupt("return", signMessage(address, message));

                              case 2:
                              case "end":
                                return _context14.stop();
                            }
                          }
                        }, _callee14);
                      }));

                      function eth_sign(_x16) {
                        return _eth_sign.apply(this, arguments);
                      }

                      return eth_sign;
                    }(),
                    personal_sign: function () {
                      var _personal_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref16) {
                        var _ref16$params, message, address;

                        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                          while (1) {
                            switch (_context15.prev = _context15.next) {
                              case 0:
                                _ref16$params = _slicedToArray(_ref16.params, 2), message = _ref16$params[0], address = _ref16$params[1];
                                return _context15.abrupt("return", signMessage(address, message));

                              case 2:
                              case "end":
                                return _context15.stop();
                            }
                          }
                        }, _callee15);
                      }));

                      function personal_sign(_x17) {
                        return _personal_sign.apply(this, arguments);
                      }

                      return personal_sign;
                    }(),
                    eth_signTypedData: function () {
                      var _eth_signTypedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref17) {
                        var _ref17$params, address, typedData, account, domainHash, messageHash;

                        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                          while (1) {
                            switch (_context16.prev = _context16.next) {
                              case 0:
                                _ref17$params = _slicedToArray(_ref17.params, 2), address = _ref17$params[0], typedData = _ref17$params[1];

                                if (accounts && accounts.length && accounts.length > 0) {
                                  _context16.next = 3;
                                  break;
                                }

                                throw new Error('No account selected. Must call eth_requestAccounts first.');

                              case 3:
                                account = accounts.find(function (account) {
                                  return account.address === address;
                                }) || accounts[0];
                                domainHash = TypedDataUtils.hashStruct('EIP712Domain', typedData.domain, typedData.types, SignTypedDataVersion.V3).toString('hex');
                                messageHash = TypedDataUtils.hashStruct(typedData.primaryType, typedData.message, typedData.types, SignTypedDataVersion.V3).toString('hex');
                                return _context16.abrupt("return", eth.signEIP712HashedMessage(account.derivationPath, domainHash, messageHash).then(function (result) {
                                  var v = (result['v'] - 27).toString(16);

                                  if (v.length < 2) {
                                    v = '0' + v;
                                  }

                                  return "0x".concat(result['r']).concat(result['s']).concat(v);
                                }));

                              case 7:
                              case "end":
                                return _context16.stop();
                            }
                          }
                        }, _callee16);
                      }));

                      function eth_signTypedData(_x18) {
                        return _eth_signTypedData.apply(this, arguments);
                      }

                      return eth_signTypedData;
                    }(),
                    wallet_switchEthereumChain: function () {
                      var _wallet_switchEthereumChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref18) {
                        var _ref18$params, chainId;

                        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                          while (1) {
                            switch (_context17.prev = _context17.next) {
                              case 0:
                                _ref18$params = _slicedToArray(_ref18.params, 1), chainId = _ref18$params[0].chainId;
                                currentChain = chains.find(function (_ref19) {
                                  var id = _ref19.id;
                                  return id === chainId;
                                }) || currentChain;

                                if (currentChain) {
                                  _context17.next = 4;
                                  break;
                                }

                                throw new Error('chain must be set before switching');

                              case 4:
                                eventEmitter.emit('chainChanged', currentChain.id);
                                return _context17.abrupt("return", null);

                              case 6:
                              case "end":
                                return _context17.stop();
                            }
                          }
                        }, _callee17);
                      }));

                      function wallet_switchEthereumChain(_x19) {
                        return _wallet_switchEthereumChain.apply(this, arguments);
                      }

                      return wallet_switchEthereumChain;
                    }(),
                    wallet_addEthereumChain: null
                  });
                  provider.on = eventEmitter.on.bind(eventEmitter);
                  return _context18.abrupt("return", {
                    provider: provider
                  });

                case 42:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));

        function getInterface(_x10) {
          return _getInterface.apply(this, arguments);
        }

        return getInterface;
      }()
    };
  };
}

export default ledger;